// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__113cR","range":"MonthRangeSwitch_range__16fb7","disabled":"MonthRangeSwitch_disabled__2SN5H"};